import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { queryClient } from './lib/queryClient';
import { applyThemeEarly } from './lib/theme';
import { applyScaleEarly } from './lib/uiscale';
import './styles.css';

// Set the theme class and UI scale before the first paint so there's no flash
// of the wrong palette or a resize jump on load.
applyThemeEarly();
applyScaleEarly();

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
